
export class GanttData {

    stationGroups = new Array<StationGroup>();
	stations = new Array<Station>();

    constructor(data: any) {
        if (data.stationGroups) {
            for (let stationGroup of data.stationGroups) {
                this.stationGroups.push(new StationGroup(stationGroup));
            }
        }
        if (data.stations) {
            for (let station of data.stations) {
                this.stations.push(new Station(station));
            }
        }
    }

}

export class StationGroup {

    name: string;

    rowCount: number;

    transports = new Array<TransportDetail>();

    transportLists = new Array<Array<TransportDetail>>();

    stations = new Array<StationReference>();

    stationsList = new Array<Station>();

    constructor(group: any) {
        this.name = group.name;
        this.rowCount = group.rowCount;
        if (group.transports) {
            for (let transport of group.transports) {
                this.transports.push(new TransportDetail(transport));
            }
        }
        if (group.stations) {
            for (let station of group.stations) {
                this.stations.push(new StationReference(station));
            }
        }
        this.calculateTransportsList();
    }

    calculateTransportsList() {
        this.transportLists = new Array<Array<TransportDetail>>();
        // identify max row
        let maxRow = 0;
        for (let transportDetail of this.transports) {
            if (maxRow < transportDetail.row) {
                maxRow = transportDetail.row;
            }
        }
        for (let i = 0; i < maxRow; i++) {
            this.transportLists.push(new Array<TransportDetail>());
        }
        for (let transportDetail of this.transports) {
            this.transportLists[transportDetail.row-1].push(transportDetail);
        }
    }

}

export class StationReference {

    stationId: number;

    constructor(station: any) {
        this.stationId = station.stationId;
    }

}

export class Station {

    id: number;

    name: string;

    transports = new Array<TransportDetail>();

    constructor(station: any) {
        this.id = station.id;
        this.name = station.name;
        if (station.transports) {
            for (let transport of station.transports) {
                this.transports.push(new TransportDetail(transport));
            }
        }
    }

}

export enum TransportRelevance {
  NOT_RELEVANT = 'NOT_RELEVANT', CURRENT_RELEVANT = 'CURRENT_RELEVANT', ARCHIVED = 'ARCHIVED'
}

export class TransportDetail {

    transportId: number;
    relevance: TransportRelevance;
    carrier: string;
    numberPlate: string;
    reference: string;
    options: string;
    style: string;
    supplier: string;

    row: number;
    column: number;
    width: number;

    constructor(transport: any) {
        this.transportId = transport.transportId;
        this.carrier = transport.carrier;
        this.numberPlate = transport.numberPlate;
        this.reference = transport.reference;
        this.options = transport.options;
        this.row = transport.row;
        this.column = transport.column;
        this.width = transport.width;
        this.style = transport.style;
        this.relevance = transport.relevance;
        this.supplier = transport.supplier;
    }

}

export class GanttSelection {

    date: Date;
	stationGroupId: number;
    stationSetId: number;
    mode: string;

    constructor(selection: any) {
        this.date = selection.date;
        this.stationGroupId = selection.stationGroupId;
        this.stationSetId = selection.stationSetId;
        this.mode = selection.mode;
    }
}
